<template>
  <div class="">
    <rule-list v-for="rule in formattedRuleList" :key="rule.id" :rule-list-data="rule" @remove-rule="removeRuleLayout" :selectedId="selectedId" @update:selectedId="setSelectedId"></rule-list>
  </div>
</template>
<script>
import ruleList from '../Rule/RuleList.vue';

export default {
  name: 'ruleLayout',
  components: {
    'rule-list': ruleList,
  },
  props: { ruleList: Array },
  data() {
    return {
      formattedRuleList: [],
      selectedId: null
    };
  },
  watch: {
    selectedId() {
      this.$emit('clicked-rule-id', this.selectedId);
    },
    ruleList() {
      this.formattedRuleList = this.formatArray();
    },
  },
  mounted() {
    this.formattedRuleList = this.formatArray();
  },
  methods: {
    setSelectedId(id) {
      this.selectedId = id;
    },
    formatArray() {
      const result = [];
      const levelsMap = new Map();
      this.ruleList.forEach((item) => {
        const {
          id, name, level, type
        } = item;
        if (level === 0) {
          result.push({
            id,
            name,
            level,
            type,
            child: [],
          });
          levelsMap.set(0, result[result.length - 1].child);
        } else {
          const parentLevel = levelsMap.get(level - 1);
          const newItem = {
            id,
            name,
            level,
            type,
            child: [],
          };
          parentLevel.push(newItem);
          levelsMap.set(level, newItem.child);
        }
      });

      return result;
    },
    removeRuleLayout(rule) {
      this.$emit('remove-rule-data', rule);
    },
  },
};
</script>
